import React from 'react';
import styled from 'styled-components';
import { Container } from '@mui/material';
import SiteHeader from '../Header';

const OnboardingRightLayout = () => {
  return (
    <Wrapper>
      <div className="content">
        <div className="text">
          This will help us recommend products you can use to get started
        </div>
        <img src="/images/onboarding.png" className="gpk" />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  .content {
    position: relative;
    padding-top: 30%;
    .text {
      max-width: 300px;
    }
    .gpk {
      position: absolute;
      right: 0;
      width: 80%;
      z-index: -1;
      max-width: 200px;
      top: 20%;
    }
  }
`;

export default OnboardingRightLayout;
